export default {
    list: {
        title: "Activity",
        subtitle: "View recent activity",
        loading: "Loading activity...",
    },
    sender: {
        title: "Activity",
        subtitle: "Updates and notifications for your Sender account",
    },
    shipper: {
        title: "Activity",
        subtitle: "Updates and notifications for your Shipper account",
    },
    receiver: {
        title: "Activity",
        subtitle: "Updates and notifications for your Receiver account",
    },
    freightForwarder: {
        title: "Activity",
        subtitle: "Operational updates for your Freight Forwarder account",
    },
    actions: {
        markAllAsRead: "Mark all as read",
        markingAsRead: "Marking...",
    },
    tradeComms: {
        title: "Trade Communications",
        goToEmailSettings: "Go to Email Settings",
        sidebarTitle: "Trade Communications",
        collapseSidebar: "Collapse sidebar",
        expandSidebar: "Expand sidebar",
        allInbox: "All Inbox Email",
        allLimbo: "All Review Needed Emails",
        accounts: "Accounts",
        accountAll: "All account email",
        reviewNeeded: "Review Needed",
        selectEmail: "Select an email to view content",
        noInbox: "No inbox emails",
        noLimbo: "No limbo emails",
        searchEmails: "Search emails...",
        yesterday: "Yesterday",
    },
    systemLogs: {
        title: "System Activity Logs",
    },
    activityItem: {
        actionNeeded: "Action needed",
        reviewed: "Reviewed",
        requiresReview: "Requires review",
        account: "Account:",
        from: "From:",
        received: "Received:",
        subject: "Subject:",
        hideRecap: "Hide recap",
        showRecap: "Show recap",
        file: "File:",
        type: "Type:",
        category: "Category:",
        uploadedBy: "Uploaded by:",
        classifiedBy: "Classified by:",
        source: "Source:",
        sourceEmail: "From email",
        sourceManual: "Manual upload",
        reportedBy: "Reported by:",
        severity: "Severity:",
        name: "Name:",
        email: "Email:",
        company: "Company:",
        role: "Role:",
        modifiedBy: "Modified by:",
        modifiedFields: "Modified fields:",
        delayHours: "{{hours}}h delay",
        originalEta: "Original ETA:",
        currentEta: "Current ETA:",
        vessel: "Vessel:",
        passed: "{{count}} passed",
        failed: "{{count}} failed",
        missing: "{{count}} missing",
        skipped: "{{count}} skipped",
        hideDetails: "Hide details",
        issuesDetected: "{{count}} issues detected",
        moreOthers: "+ {{count}} others",
        risk: "Risk:",
        activeIssues: "Active issues:",
        issuesAutoClosed: "{{count}} issues auto-closed",
        container: "Container:",
        moreAttachments: "+ {{count}} attachments",
        containerDeleted: "Container deleted",
        containerDeletedTooltip: "This container has been deleted",
        synced: "Synced",
        fields: {
            actualDepartureDate: "Actual departure date",
            riskScore: "Risk level",
            destinationPortId: "Destination port",
            totalValueUsd: "Value (USD)",
            physicalStatus: "Physical status",
            status: "Status",
            containerNumber: "Container number",
            bookingNumber: "Booking number",
            estimatedArrivalDate: "ETA",
            estimatedDepartureDate: "ETD",
        },
    },
    emailActions: {
        markNotInContext: {
            label: "Not in Context",
            confirmTitle: "Remove Email from Context",
            confirmMessage:
                "Are you sure you want to mark this email as not relevant? The email will be removed from the logistics context and will no longer be processed.",
            cancel: "Cancel",
            confirm: "Remove from Context",
            marking: "Removing...",
            success: "Email marked as not in context",
            error: "Error marking email",
        },
        closeDetail: "Close detail",
        associateContainer: {
            label: "Associate to Container",
            title: "Associate Email to Container",
            description: "Select the container to associate with this email. The system will automatically process the content.",
            inputLabel: "Container Number",
            inputPlaceholder: "Search and select a container...",
            loadingContainers: "Loading containers...",
            cancel: "Cancel",
            confirm: "Associate",
            associating: "Associating...",
            success: "Email associated to container successfully",
            error: "Error associating email",
        },
    },
    activityFeed: {
        categories: {
            document: "Documents",
            tracking: "Tracking",
            contact: "Address Book",
            agent: "System",
            other: "Other",
        },
        sectionSettings: "Section settings",
        sectionOrderVisibility: "Section order & visibility",
        loadMoreActivities: "Load more activities",
        nextSlide: "Next slide",
        noActivities: "No activities found with the selected filters.",
        noMoreToLoad: "No more to load",
        expandSection: "Expand {{label}}",
        collapseSection: "Collapse {{label}}",
        moveUp: "Move {{label}} up",
        moveDown: "Move {{label}} down",
        show: "Show",
        hide: "Hide",
    },
};
